const MAX_FILE_MB = 200;

export const getAttachmentMaxFileMb = (user) => {
  const configured = Number(user?.DroitsCompte?.AttachmentMaxFileMb);
  if (Number.isFinite(configured) && configured > 0) {
    return Math.min(MAX_FILE_MB, Math.max(1, Math.trunc(configured)));
  }

  const gradeId = Number(user?.GradeID);
  if (gradeId === 4) return 15;
  if ([1, 2, 5, 6].includes(gradeId)) return 200;
  return 5;
};
